<div  v-if="shouldRenderConfig" v-bind:class="getClassName">    
    <button type="button" class="btn btn-primary" v-bind:class="activeClass()" v-on:click="onClickSelectPageOption(code)">
        <div v-bind:class="getClassName + 'Index'">{{index + 1}}</div>
        <div v-bind:class="getClassName + 'Label'">{{index + 1}}. {{name}}</div>
        <appTooltip v-if="tooltip" :tooltip="tooltip"></appTooltip>
    </button>
    
    <div v-if="getPageAttributesInPageOptions">
        <appPageOptionAttributesContainer v-bind:code="code"></appPageOptionAttributesContainer>
    </div>
</div>